import Immutable from 'immutable'
import {
  GET_LEGAL_MANIFEST_BAGGAGES,
  FLAG_GETTING_LEGAL_MANIFEST_BAGGAGES,
  CLEAR_LEGAL_MANIFEST_BAGGAGES,
} from '../../../actions/types/legal'

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
})

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_LEGAL_MANIFEST_BAGGAGES:
      return state.setIn(['all', 'loading'], action.payload)
    case GET_LEGAL_MANIFEST_BAGGAGES:
      return state.setIn(['all', 'content'], Immutable.List(action.payload))
    case CLEAR_LEGAL_MANIFEST_BAGGAGES:
      return state.setIn(['all', 'content'], INITIAL_STATE.getIn(['all', 'content']))
    default:
      return state
  }
}